<div class="sub-tabs ms-5 mb-3">
    <button type="button" *ngFor="let tab of subTabs" [class.active]="activeSubTab === tab.id"
        (click)="selectSubTab(tab.id)">{{ tab.labelKey | translate }}</button>
</div>

@if (activeSubTab === 'Energy Reads') {
<div class="ms-5 me-5">
    <app-energy-reads [meterId]="meterId"></app-energy-reads>
</div>
}
@if (activeSubTab === 'Power Demand') {
<div class="ms-5 me-5">
    <app-power-demand [meterId]="meterId"></app-power-demand>
</div>
}
@if (activeSubTab === 'Voltage Current') {
<div class="ms-5 me-5">
    <app-voltage-current [meterId]="meterId"></app-voltage-current>
</div>
}
